export default {
  white: '#ffffff',
  black100: '#f6f6f6',
  black200: '#ededed',
  black300: '#dcdcdc',
  black400: '#c5c5c5',
  black500: '#adadad',
  black600: '#949494',
  black700: '#767676',
  black800: '#555555',
  black900: '#383838',
  black1000: '#111111',
  black: '#111111',
  transparent: 'rgba(0, 0, 0, 0)',

  // Colorful colors

  blue200: '#d4f9ff',
  blue400: '#b1eefc',
  blue600: '#63daff',
  blue800: '#0a85ea',
  blue900: '#0076d6',
  blue1000: '#0668ba',

  green200: '#d0fce4',
  green400: '#abffdb',
  green600: '#5befbd',
  green800: '#23d09c',
  green900: '#2ab589',

  yellow200: '#fefbb8',
  yellow400: '#fbf1a0',
  yellow600: '#fce76b',
  yellow800: '#f2d211',
  yellow900: '#d9bc2d',

  red200: '#ffd7dc',
  red400: '#ffaab9',
  red600: '#ff7885',
  red800: '#f44e66',
  red900: '#d44648',
  red1000: '#c9292c',

  purple200: '#e1e1ff',
  purple400: '#c6befc',
  purple600: '#9986f7',
  purple800: '#7646ec',
  purple900: '#6944ce',
};
